import { useState, useEffect } from "react";

import useService from "../hooks/useService";

const useActionTypes = () => {
  const enumRepository = useService("repositories/enum-repository");
  const [actionTypes, setActionTypes] = useState(null);

  useEffect(() => {
    async function fetchActionTypes() {
      const actionTypes = await enumRepository.query({
        urlPath: "core/dynamic-options/action_types",
      });

      const transformedTypes = actionTypes.reduce((acc, item) => {
        const keyParts = item.label.toLowerCase().split(" ");
        const key = keyParts[0];
        acc[key] = item;
        return acc;
      }, {});

      setActionTypes(transformedTypes);
    }

    fetchActionTypes();
  }, [enumRepository]);

  return actionTypes;
};

export default useActionTypes;
